import { RegionModel } from 'services/EpdClient';
import { Option } from 'types/types';

const getAvailableRegionsForCountryOptions = (countryId: string, regions: RegionModel[]) => {
  const options = regions
    .filter((region) => region.countryId === countryId)
    .map((region) => {
      return { value: region.id, label: region.name } as Option;
    });

  return options;
};

export default getAvailableRegionsForCountryOptions;
